import "devextreme/dist/css/dx.light.css";
import "./App.css";
import { Outlet } from "react-router-dom";
import TopNavigation from "./Components/Navigation/TopNav";
import SideNav from "./Components/Navigation/SideNav";
import { useState } from "react";
import RouteAnalytics from "./Components/Common/RouteAnalytics";
import QuickBooksDownBanner from "./Components/Admin/QuickBooksDownBanner";

function App() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <RouteAnalytics />
      <TopNavigation setShow={setIsOpen}></TopNavigation>
      <div className="flex">
        <SideNav show={isOpen} handleClose={handleClose}></SideNav>

        <div className="m-2 p-6 w-full text-left border border-gray-300 bg-white rounded-lg shadow-md">
          <QuickBooksDownBanner />
          <Outlet></Outlet>
        </div>
      </div>
    </>
  );
}

export default App;
